import React, { useState } from "react";
import { faArrowCircleUp, faAngleUp, faArrowAltCircleUp, faCaretSquareUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ScrollButton = () => {
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setVisible(true);
    } else if (scrolled <= 300) {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
      /* you can also use 'auto' behaviour
		in place of 'smooth' */
    });
  };

  window.addEventListener("scroll", toggleVisible);

  return (
    <div className="scrollBtn">
      <FontAwesomeIcon
        icon={faAngleUp}
        className={visible ? "" : "d-none"}
        onClick={scrollToTop}
        data-toggle="tooltip"
        title="Scroll to the top"
      />
    </div>
  );
};

export default ScrollButton;
